import React from "react";
import moment from "moment";
import "moment-timezone";

function Timezone(props) {
  let label = props.label;
  let timeZone = moment.tz.guess();
  let time = new Date();
  let timeZoneOffset = time.getTimezoneOffset();
  let timezoneAbbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);

  return (
    <div className="timezoneNote">
      {label} {timezoneAbbr}
    </div>
  );
}

export default Timezone;
